import { z } from 'zod'

export const executionStepDtoSchema = z.object({
  id: z.string(),
  stepIndex: z.number().optional(),
  stepId: z.string(),
  stepName: z.string().optional().default(''),
  stepType: z.string().optional().default(''),
  status: z.string(),
  startedAt: z.string().nullable().optional(),
  completedAt: z.string().nullable().optional(),
  error: z.string().nullable().optional(),
  output: z.string().nullable().optional(),
  logs: z.array(z.object({
    id: z.string(),
    level: z.string(),
    message: z.string(),
    timestamp: z.string(),
  })).optional().default([]),
})

export type ExecutionStepDto = z.infer<typeof executionStepDtoSchema>

export const executionDtoSchema = z.object({
  id: z.string(),
  workflowId: z.string(),
  status: z.string(),
  triggerType: z.string().nullable().optional(),
  tenantId: z.string().optional(),
  startedAt: z.string().nullable().optional(),
  completedAt: z.string().nullable().optional(),
  error: z.string().nullable().optional(),
  correlationId: z.string().nullable().optional(),
  createdAt: z.string(),
  totalSteps: z.number().optional(),
  completedSteps: z.number().optional(),
  workflowName: z.string().nullable().optional(),
  isWorkflowDeleted: z.boolean().optional().default(false),
  durationMs: z.number().nullable().optional(),
  steps: z.array(executionStepDtoSchema).nullable().optional(),
})

export type ExecutionDto = z.infer<typeof executionDtoSchema>

export const pagedExecutionDataSchema = z.object({
  items: z.array(executionDtoSchema),
  totalCount: z.number(),
  page: z.number(),
  pageSize: z.number(),
  totalPages: z.number(),
})
